import React, { useContext } from 'react'
import resumeCss from './resume.module.less'
import ManagersContext from '../../containers/ManagersContext'
import { PositionObj } from '../../managers/objResume'

export default function InnerPageResume () {
  const {objResume} = useContext(ManagersContext)
  const resume = objResume.resume
  return (
    <table id={resumeCss.resTbl} border={0} width='500' cellSpacing='0' cellPadding={0}>
      <tbody>
        <tr>
          <td colSpan={2}>
            <table id={resumeCss.resHeaderTbl} border={0} width='560' cellSpacing='0' cellPadding={0}>
              <tbody>
                <tr>
                  <td id={resumeCss.nameAddress}>
                    {resume.nname}
                    <ul id={resumeCss.address}> {
                      resume.addressLines.map((lline:string, k:number) => (
                        <li key={`addressLI_${k}`}>{lline}</li>
                      ))
                    }
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td className={resumeCss.sectHead} colSpan={2}>
            Summary of Qualifications
          </td>
        </tr>
        <tr>
          <td colSpan={2}> {
            resume.qualSummary.map((qual:string, m:number) => (
              <p key={`p_${m}`} className={resumeCss.summary}>{qual}</p>
            ))
          }
          </td>
        </tr>
        {/* <tr> */}
        {/*  <td className={resumeCss.sectHead} colspan={2}> */}
        {/*    Objectives */}
        {/*  </td> */}
        {/* </tr> */}
        {/* <tr> */}
        {/*  <td colspan={2}}> { */}
        {/*    resume.skillsetSummary.map((skill:string) => ( */}
        {/*      <p className={resumeCss.summary}>{skill}</li> */}
        {/*    )} */}
        {/*  </td> */}
        {/* </tr> */}

        <tr>
          <td className={resumeCss.sectHead} colSpan={2}>
            Employment History
          </td>
        </tr>
        {
          resume.positionObjArray.map((ppos:PositionObj, i:number) => (
            <tr key={`outerRow_${i}`}>
              <td>
                <table border={0}>
                  <tbody>
                    <tr>
                      <td>
                        <table border={0} className={resumeCss.position}>
                          <tbody>
                            <tr>
                              <td width='372' style={{padding: '5px'}}>
                                <span className={resumeCss.company}>{ppos.company}</span>
                                <span className={resumeCss.city}>{' '}({ppos.location})</span>
                                <br />
                                <span className={resumeCss.basisLabel}>Basis: </span>
                                <span className={resumeCss.basis}>{ppos.basis}</span>
                              </td>
                              <td className={resumeCss.timeTitle} width='128'>
                                {ppos.dates}
                                <br />{ppos.ttitle}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <ul> {
                          ppos.listTextArray.map((line, j) => (
                            <li key={`innerLI_${j}`} dangerouslySetInnerHTML={{ __html: line }} />
                          ))
                        }
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          ))
        }
      </tbody>
    </table>
  )
}
